export const WebToHomeDisabled = () => {
  return (
    <div className="bg-danger-300 text-l flex items-center justify-center gap-2 rounded-sm p-4 text-white">
      Web-to-Home is not enabled for this organization.
    </div>
  )
}
